import AScene from "../../library/ExtendedObjects/AScene.js";
import Backgrounds from "../Backgrounds.js";
import gameData from "../../gameData.js";

export default class Menu extends AScene
{
    create()
    {
        this.background = new Backgrounds(this);
        this.background.displayBG(gameData.backgroundClasses.moneyBG, false);

        this.register = this.add.container(this.mid.x, 270);
        this.registerTray = this.addImage(0, 0, "Menu_RgstrTray", this.register);
        this.registerBG = this.addDropShadow(this.addImage(0, 0, "Menu_Rgstr", this.register));
        this.registerTxt = this.addText(0, -166, 43, 0x83BD05, gameData.fonts.comfortaa_bold, "SELECT A GAME MODE", this.register, true);
        
        this.denominationBtns = [];
        
        this.addDenominationBtn(-100, "CoinsBtn_Unselected", "CoinsBtn_Selected", gameData.denominationTypes.COINS);
        this.addDenominationBtn(-100, "DollarsBtn_Unselected", "DollarsBtn_Selected", gameData.denominationTypes.DOLLARS);
        this.addDenominationBtn(0, "CoinsDollarsBtn_Unselected", "CoinsDollarsBtn_Selected", gameData.denominationTypes.COINS_DOLLARS);
        this.curDenominationBtn = null;

        this.playButton = this.addButton(200, 5, "PlayBtn_Unselected", ()=>{
            this.killTween(this.register);
            this.addTween(this.register, 500, {y: 1000}, Phaser.Math.Easing.Sine.Out, ()=>{
                this.scene.start("Descriptions");
            });
        }, this.register);
        this.playButton.setEnabled(false);

        this.registerOpenY = 300;
        this.registerClosedY = 0;
        this.registerTray.isOpen = false;
        this.registerTray.curMoney = null;
        this.curBtnY = null;
        
        this.animateIn();
    }

    animateIn()
    {
        this.register.y = -400;
        let coins = [];
        let coinKeys = Object.keys(gameData.coinData);
        for(let i = 0; i < 12; i++)
        {
            let idx = Phaser.Math.Between(0, coinKeys.length - 1);
            let key = coinKeys[idx];
            let data = gameData.coinData[key]; 
            let coin = this.addSpine(0, Phaser.Math.Between(-300, 0),"coin", "flipForward", true);

            coin.play("flipForward", true).timeScale = Phaser.Math.FloatBetween(5, 9);
            coin.spine.setScale(data.scale * .3);
            coin.setSkin(key);
            coin.spine.x = Phaser.Math.Between(-250, 250);
            coins.push(coin.spine);

            this.register.add(coin.spine);
            this.register.sendToBack(coin.spine);
            this.register.sendToBack(this.registerTray);
        }

        this.playSound("tweens");
        this.addDelay(300, ()=>{
            coins.forEach((coin)=>{
                this.addTween(coin, 800, {y: Phaser.Math.Between(550, 700), x: coin.x * 1.9, scaleX: coin.scaleX * 2, scaleY: coin.scaleX * 2}, Phaser.Math.Easing.Linear.Linear);
            });
        });
        
        this.addTween(this.register, 500, {y: 270}, Phaser.Math.Easing.Sine.In, ()=>{
            this.playSound("register_open");
            this.addTween(this.registerTray, 1200, {y: this.registerOpenY, easeParams: [0, .6]}, "Elastic", ()=>{
                this.playSound("register_close");
                this.addTween(this.registerTray, 300, {y: this.registerClosedY}, Phaser.Math.Easing.Sine.Out);
                this.addTween(this.register, 300, {y: this.mid.y}, Phaser.Math.Easing.Sine.Out);
            });
        });
    }

    addDenominationBtn(x, unselectedFrame, selectedFrame, denominationType)
    {
        this.curBtnY == null ? this.curBtnY = -40 : this.curBtnY += 95;

        let btn = this.addButton(x, this.curBtnY, selectedFrame, ()=>{
            this.denominationSelected(btn);
        }, this.register);
        btn.selectedFrame = selectedFrame;
        btn.unselectedFrame = unselectedFrame;
        btn.denominationType = denominationType;
        this.denominationBtns.push(btn);
    }

    firstDenominationSelected()
    {
        this.killTween(this.register);
        this.addTween(this.register, 300, {y: 270}, Phaser.Math.Easing.Sine.Out);
        this.denominationBtns.forEach((btn)=>{
            btn.setFrame(btn.unselectedFrame);
        });
        this.playButton.setFrame("PlayBtn");
        this.playButton.setEnabled(true);
        this.addTween(this.registerTxt, 200, {alpha: 0}, Phaser.Math.Easing.Sine.Out, ()=>{
            this.registerTxt.text = "PRESS PLAY TO START";
            this.addTween(this.registerTxt, 200, {alpha: 1}, Phaser.Math.Easing.Sine.Out);
        });
    }

    denominationSelected(btn)
    {
        if(this.curDenominationBtn != null)
        {
            this.curDenominationBtn.setFrame(this.curDenominationBtn.unselectedFrame);
        }
        else this.firstDenominationSelected();

        this.playSound("register_open");
        gameData.denominations = btn.denominationType;
        this.curDenominationBtn = btn;
        this.curDenominationBtn.setFrame(this.curDenominationBtn.selectedFrame);

        this.showMoneyType(this.curDenominationBtn.denominationType)
    }

    showMoneyType(denominationType)
    {
        this.killTween(this.registerTray);
        if(this.registerTray.isOpen)
        {
            this.addTween(this.registerTray.curMoney, 200, {y: 0}, Phaser.Math.Easing.Sine.Out);
            this.addTween(this.registerTray, 200, {y: this.registerClosedY}, Phaser.Math.Easing.Sine.Out, ()=>{
                this.registerTray.curMoney.destroy();
                this.openRegister(denominationType);
            });
        }
        else
        {
            this.openRegister(denominationType);
        }
        this.registerTray.isOpen = true;
    }

    openRegister(denominationType)
    {
        this.addTween(this.registerTray, 1200, {y: this.registerOpenY, easeParams: [0, .6]}, "Elastic");
        
        let imageKeys = {0: "Menu_RgstrCns", 1: "Menu_RgstrDlrs", 2: "Menu_RgstrCnsDlrs"};
        this.registerTray.curMoney = this.addImage(0, 0, imageKeys[denominationType], this.register);
        this.register.sendToBack(this.registerTray.curMoney);
        this.register.sendToBack(this.registerTray);

        this.addTween(this.registerTray.curMoney, 1200, {y: 300, easeParams: [0, .6]}, "Elastic");
    }
}